module.exports = __webpack_public_path__ + "static/media/zodiac_left_bg.4abf020e.png";